import { useState, useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../../../Style/pagestyle.scss";
import EmptyData from "../../Include/EmptyData/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import ScheduleCard from "./ScheduleCard";
import ScheduleForm from "./ScheduleForm";
import useGetScheduleByClass from "../../../Hooks/useGetScheduleByClass";

import { AuthContext } from "../../../Context/AuthContext";
import { ButtonCreate } from "../../../Utils/Component";

export default function Schedule({ classId, classData }) {
  // Change Language
  const { t } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { loading, refetch, tableData } = useGetScheduleByClass({
    classId: classId,
  });

  let arr = tableData?.map((e) => e?.scheduleData?.length);
  let maxNumber = Math.max(...arr);

  const translateDay = (day) => {
    const dayOfWeek = {
      Monday: t("thead_monday"),
      Tuesday: t("thead_tuesday"),
      Wednesday: t("thead_wednesday"),
      Thursday: t("thead_thursday"),
      Friday: t("thead_friday"),
      Saturday: t("thead_saturday"),
      Sunday: t("thead_sunday"),
    };
    return dayOfWeek[day] ? dayOfWeek[day] : day;
  };
  return (
    <div>
      {/* ================== Filters ================== */}
      <Box sx={{ marginTop: "10px" }}>
        <Grid
          container
          spacing={3}
          sx={{ minHeight: "100px", marginBottom: 1.9 }}
        >
          {/* Create Button */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn="btn-create"
              classIcon="icon-add"
            />
            {open && (
              <ScheduleForm
                open={open}
                classId={classId}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <table
          className="table"
          style={{ borderCollapse: "collapse", width: "100%" }}
        >
          {loading ? (
            <tbody className="body">
              <tr className="body-row">
                <td className="body-cell">
                  <LoadingPage />
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              {tableData?.length === 0 || tableData?.length === undefined ? (
                <tbody>
                  <tr>
                    <td>
                      <EmptyData />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <>
                  <tbody>
                    {tableData?.map((row, index) => {
                      const newMaxNumber = maxNumber < 4 ? 4 : maxNumber;
                      const RemainSpaceSchedule = Array(
                        newMaxNumber - row?.scheduleData?.length,
                      )
                        .fill()
                        .map((e, index) =>
                          index < 9 ? `0${index + 1}` : `${index + 1}`,
                        );

                      return (
                        <tr key={index}>
                          <td
                            width="5%"
                            align="center"
                            style={{
                              border: "1px solid #131870",
                              paddingLeft: 10,
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#131870 !important",
                                fontWeight: "bold",
                              }}
                            >
                              {translateDay(row?.day)}
                            </Typography>
                          </td>

                          {row?.scheduleData?.map((e, index) => (
                            <td
                              key={index}
                              width="10%"
                              align="center"
                              style={{ border: "1px solid #131870" }}
                            >
                              <ScheduleCard
                                editData={e}
                                day={row?.day}
                                mainId={row?._id}
                                classData={classData}
                                setRefetch={refetch}
                              />
                            </td>
                          ))}
                          {RemainSpaceSchedule?.map((e) => (
                            <td
                              key={e}
                              width="10%"
                              style={{
                                border: "1px solid #131870",
                                width: "10%",
                              }}
                            ></td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              )}
            </>
          )}
        </table>
      </Box>
    </div>
  );
}
